// extracted by mini-css-extract-plugin
export default {"article":"index_article_QJWPB","image":"index_image_M6-iw","textPart":"index_textPart_f5ZOg","subTitle":"index_subTitle_pt51N"};